import React from 'react';
import { Box, Typography } from '@mui/material';

interface ProductCustomDescriptionBoxProps {
    customDescription?: string;
    variant?: 'default' | 'compact';
    className?: string;
}

const ProductCustomDescriptionBox: React.FC<ProductCustomDescriptionBoxProps> = ({
    customDescription,
    variant = 'default',
    className
}) => {
    // Si pas de description personnalisée, ne rien afficher
    if (!customDescription || customDescription.trim() === '') {
        return null;
    }

    const isCompact = variant === 'compact';

    return (
        <Box
            className={className}
            sx={{
                backgroundColor: '#e8f4fd',
                border: '3px solid #1976d2',
                borderRadius: 3,
                padding: isCompact ? 2.5 : 4,
                marginBottom: isCompact ? 2 : 4,
                boxShadow: '0 6px 12px rgba(25, 118, 210, 0.3)',
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(90deg, #1976d2, #42a5f5, #1976d2)',
                }
            }}
        >
            <Typography
                variant={isCompact ? "h6" : "h6"}
                component="h2"
                gutterBottom
                sx={{
                    color: '#1565c0',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    mb: 2,
                    fontSize: '1.1rem'
                }}
            >
                📋 Description du produit
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    color: '#424242',
                    lineHeight: 1.6,
                    textAlign: 'justify',
                    fontStyle: 'italic',
                    fontSize: '0.9rem'
                }}
            >
                {customDescription}
            </Typography>
        </Box>
    );
};

export default ProductCustomDescriptionBox;
